import React from 'react';
import classNames from 'classnames/bind';
import { parseTextWithLinksAndBold } from 'sections/Resources/FreightDictionary/helpers/textParser';
import styles from 'sections/Resources/FreightDictionary/landing/SectionDescription/SectionDescription.module.scss';

const cn = classNames.bind(styles);

type Content = {
  title: string;
  paragraphs?: string[];
  list?: {
    title: string;
    items: string[];
  };
  listNum?: {
    title: string;
    items: string[];
  }
  summary?: string;
};

type SectionDescriptionProps = {
  titleH1: string;
  titleH2?: string;
  description?: string;
  content?: Content[];
};

const SectionDescription = ({ titleH1, description, content }: SectionDescriptionProps) => {

  return (
    <section className={cn('description')}>
      <div className={cn('container')}>
        {content ? (
          <>
            {content.map(({ title, paragraphs, list, listNum, summary }, idx) => {
              return (
                <React.Fragment key={idx}>
                  <h2 className={cn('description__heading')}>
                    {title}
                  </h2>
                  <div>
                    {paragraphs && paragraphs.map((paragraph, idx) => (
                      <p key={idx}
                        className={cn('description__paragraph')}>{parseTextWithLinksAndBold(paragraph, cn, 'description')}</p>
                    ))}
                  </div>
                  {list && (
                    <>
                      {list.title && <p className={cn('description__list-title')}>{parseTextWithLinksAndBold(list.title, cn, 'description')}</p>}
                      <ul className={cn('description__benefits')}>
                        {list.items.map((item, idx) => (
                          <li className={cn('description__benefit')} key={idx}>{parseTextWithLinksAndBold(item, cn, 'description')}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  {listNum && (
                    <>
                      {listNum.title && <p className={cn('description__list-title')}>{parseTextWithLinksAndBold(listNum.title, cn, 'description')}</p>}
                      <ol className={cn('description__benefits', 'description__benefits--num')}>
                        {listNum.items.map((item, idx) => (
                          <li className={cn('description__benefit', 'description__benefit--num')} key={idx}>{parseTextWithLinksAndBold(item, cn, 'description')}</li>
                        ))}
                      </ol>
                    </>
                  )}
                  {summary && <p key={idx}
                    className={cn('description__paragraph')}>{parseTextWithLinksAndBold(summary, cn, 'description')}</p>}
                </React.Fragment>
              )
            })}
          </>
        ) : (
          <>
            <h2 className={cn('description__heading')}>
              <span>
                {titleH1} Meaning
              </span>
            </h2>
            <p className={cn('description__paragraph')}>{description}</p>
          </>
        )}
      </div>
    </section>
  );
};

export default SectionDescription;
